"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _animatedScrollTo = _interopRequireDefault(require("animated-scroll-to"));

var _cuid = _interopRequireDefault(require("cuid"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _calicoUiKit = require("@calico/calico-ui-kit");

var TITLE_HEIGHT = 9;

var scrollTo = function scrollTo(targetId) {
  var appElement = document.querySelector('#app');
  var targetElement = document.querySelector("#".concat(targetId));
  (0, _animatedScrollTo.default)(targetElement, {
    element: appElement
  });
};

var SectionBanner = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(SectionBanner, _React$Component);

  function SectionBanner() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SectionBanner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SectionBanner)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      id: (0, _cuid.default)()
    };
    return _this;
  }

  (0, _createClass2.default)(SectionBanner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style;
      var _this$props2 = this.props,
          backgroundColor = _this$props2.backgroundColor,
          color = _this$props2.color,
          content = _this$props2.content,
          order = _this$props2.order,
          title = _this$props2.title;
      var id = this.state.id;
      var offset = TITLE_HEIGHT * order; // 2nd offset by 2x height, 3rd by 3x, etc.

      return [_react.default.createElement("span", {
        id: id,
        key: "anchor-".concat(id),
        style: {
          borderTop: "1px solid ".concat(color),
          display: 'block',
          opacity: 0
        }
      }), _react.default.createElement("div", {
        className: (0, _classnames.default)('section-banner margin-top-6', className),
        key: "banner-".concat(id),
        style: (0, _extends2.default)({}, style, {
          bottom: "".concat(offset, "vh")
        })
      }, _react.default.createElement("div", {
        style: {
          backgroundColor: _calicoUiKit.Colors[color],
          height: 1,
          left: '-100vw',
          position: 'absolute',
          right: 0,
          top: -1
        }
      }), _react.default.createElement("div", {
        className: "bg-".concat(backgroundColor, " header ").concat(color),
        onClick: function onClick() {
          return scrollTo(id);
        },
        style: {
          height: "".concat(TITLE_HEIGHT, "vh")
        }
      }, _react.default.createElement("h2", null, title))), _react.default.createElement("div", {
        className: "section-banner",
        key: "content-".concat(id)
      }, _react.default.createElement("div", {
        className: "bg-".concat(backgroundColor, " content ").concat(color, " margin-bottom-6")
      }, content))];
    }
  }]);
  return SectionBanner;
}(_react.default.Component);

SectionBanner.defaultProps = {
  backgroundColor: 'grey-d',
  color: 'white',
  content: _react.default.createElement("div", null),
  order: 0,
  title: 'Section'
};
var _default = SectionBanner;
exports.default = _default;